import { render, staticRenderFns } from "./Aggregation.vue?vue&type=template&id=b0e83af0&scoped=true&"
import script from "./Aggregation.vue?vue&type=script&lang=js&"
export * from "./Aggregation.vue?vue&type=script&lang=js&"
import style0 from "./Aggregation.vue?vue&type=style&index=0&id=b0e83af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e83af0",
  null
  
)

export default component.exports